import { Bot } from "./bot";

export class ActionRow {
  public id: string;
  public jsonDeterminants: string = "";
  public bots: Bot[] = [];
  public sortOrderNumber: number;
  public parallel: boolean = false;
  public mandatory: boolean = false;
  public multipleBot: boolean = false;
  public multipleFieldKey: string;
  public targetTabComponentKey: string = null;
  public targetElementKey: string = null;
  // Media Manager (#95): selectedMediaFileId is the system-action equivalent of
  // targetElementKey — set when this action's intent is "download a media file".
  // selectedMediaFileName is denormalised so the picker chip can render without
  // an extra round-trip; the runtime resolves files by id.
  public selectedMediaFileId: string = null;
  public selectedMediaFileName: string = null;
}
